import { Button } from '@/components/ui/shadcn/button'
import { MagicIcon } from '@/components/ui/icons/icons-new'

interface Props {
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
  className?: string
  size?: 'default' | 'sm' | 'lg'
  text?: string
}

export const GenerateButton = ({
  onClick,
  disabled,
  loading,
  className,
  size = 'default',
  text = 'Generate',
}: Props) => {
  return (
    <Button
      variant="primary"
      onClick={onClick}
      disabled={disabled || loading}
      size={size}
      className={className}>
      <MagicIcon color="white" />
      {loading ? 'Generating...' : text}
    </Button>
  )
}
